import { ArrowRight, Calendar } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { paths } from 'src/routes/paths'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { RolePageData } from '../../types'

interface RoleCTASectionProps {
  data: RolePageData
}

export const RoleCTASection = ({ data }: RoleCTASectionProps) => {
  const navigate = useNavigate()

  const handlePrimaryCTA = () => {
    navigate(paths.loginSignUp)
  }

  return (
    <section className="w-full py-24 bg-gradient-to-b from-white via-stone-50 to-stone-100 relative overflow-hidden">
      {/* Decorative gradient blobs */}
      <div className="absolute top-0 left-1/4 w-80 h-80 bg-blue-100/30 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-stone-200/40 rounded-full blur-3xl" />

      <Column className="w-full max-w-3xl mx-auto px-8 gap-8 text-center relative z-10">
        {/* Headline */}
        <Column className="gap-4">
          <h2 className="text-3xl font-normal text-slate-800">
            Ready to make merch easy?
          </h2>
          <p className="text-slate-500 text-lg">
            Let's start with a conversation. No commitment, just clarity.
          </p>
        </Column>

        {/* CTAs */}
        <Row className="gap-4 justify-center">
          <Button
            variant="primary"
            size="lg"
            onClick={handlePrimaryCTA}
            className="px-8 py-6 text-base"
          >
            {data.cta.primary}
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>

          <Button
            variant="secondary"
            size="lg"
            onClick={() => navigate(`${paths.contact}`)}
            className="px-8 py-6 text-base"
          >
            <Calendar className="w-5 h-5 mr-2" />
            Book a meeting
          </Button>
        </Row>

        {/* Secondary CTA text */}
        {data.cta.secondary && (
          <button
            onClick={handlePrimaryCTA}
            className="text-slate-500 hover:text-slate-700 text-sm underline underline-offset-4 transition-colors"
          >
            {data.cta.secondary}
          </button>
        )}

        {/* Trust signals */}
        <p className="text-slate-400 text-sm mt-4">
          Trusted by 50+ companies across Scandinavia
        </p>
      </Column>
    </section>
  )
}
